"use client";
import React from "react";
import { CircularProgress, VeBox } from "@packages/ui/mui";

interface LoadingTableDataProps {
  fullHeight?: boolean; // Optional prop for full-height loader
  customHeight?: string; // Options prop to set the height of the loader container
}

const LoadingTableData: React.FC<LoadingTableDataProps> = ({
  fullHeight = false,
  customHeight,
}) => {
  return (
    <VeBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={customHeight ? customHeight : fullHeight ? "100vh" : "auto"} // Full height if prop is true
      paddingTop={fullHeight ? "0" : "112px"}
      paddingBottom={fullHeight ? "0" : "156px"}
      sx={{
        background: "white !important",
      }}
    >
      <CircularProgress sx={{ color: "#703DDE" }} />
    </VeBox>
  );
};

export default LoadingTableData;
